import RobotoBlack from '../src/assets/fonts/Roboto-Black.ttf';
import RobotoBold from '../src/assets/fonts/Roboto-Bold.ttf';
import RobotoLight from '../src/assets/fonts/Roboto-Light.ttf';
import RobotoMedium from '../src/assets/fonts/Roboto-Medium.ttf';
import RobotoRegular from '../src/assets/fonts/Roboto-Regular.ttf';
import RobotoThin from '../src/assets/fonts/Roboto-Thin.ttf';
import RobotoCondensedBold from '../src/assets/fonts/RobotoCondensed-Bold.ttf';
import RobotoCondensedLight from '../src/assets/fonts/RobotoCondensed-Light.ttf';
import RobotoCondensedRegular from '../src/assets/fonts/RobotoCondensed-Regular.ttf';

const fontStyles = `
    @font-face {
        src: url(${RobotoBlack});
        font-family: 'Roboto-Black';
    }
    @font-face {
        src: url(${RobotoBold});
        font-family: 'Roboto-Bold';
    }
    @font-face {
        src: url(${RobotoLight});
        font-family: 'Roboto-Light';
    }
    @font-face {
        src: url(${RobotoMedium});
        font-family: 'Roboto-Medium';
    }
    @font-face {
        src: url(${RobotoRegular});
        font-family: 'Roboto-Regular';
    }
    @font-face {
        src: url(${RobotoThin});
        font-family: 'Roboto-Thin';
    }
    @font-face {
        src: url(${RobotoCondensedBold});
        font-family: 'RobotoCondensed-Bold';
    }
    @font-face {
        src: url(${RobotoCondensedLight});
        font-family: 'RobotoCondensed-Light';
    }
    @font-face {
        src: url(${RobotoCondensedRegular});
        font-family: 'RobotoCondensed-Regular';
    }
`;

const style = document.createElement('style');

style.type = 'text/css';
if (style.styleSheet) {
  style.styleSheet.cssText = fontStyles;
} else {
  style.appendChild(document.createTextNode(fontStyles));
}

// Inject stylesheet
document.head.appendChild(style);
